import { render, staticRenderFns } from "./DefaultLayoutSidebarLogo.vue?vue&type=template&id=47beecf1&"
import script from "./DefaultLayoutSidebarLogo.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayoutSidebarLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports